//Чистка номера телефона от лишних символов
export default {
    methods: {
        clearPhoneNumber(phoneNumbers) {
            if (typeof phoneNumbers === 'object') {
                let phones = []

                phoneNumbers.forEach(item => {
                    if (item.length > 10) {
                        //Убираем первую цифру - код страны
                        phones.push(item.replace(/\D/g,'').substr(1))
                    } else {
                        phones.push(item.replace(/\D/g,''))
                    }
                })

                return phones
            }

            if (typeof phoneNumbers === 'string') {
                if (phoneNumbers.length > 10) {
                    return phoneNumbers.replace(/\D/g,'').substr(1)
                } else {
                    return phoneNumbers.replace(/\D/g,'')
                }
            }
        }
    }
}